import { memo, useMemo } from 'react';
import { useTranslate } from '@tolgee/react';
import { useGetPermission } from 'hooks/business/useNewPermisson';
import { useMark, useNonSkuMarkStock, useSkuMarkStock } from './MarkStock';
import { Tooltip, Typography } from 'antd';
import { FormOutlined, InfoCircleOutlined, FileSearchOutlined } from '@ant-design/icons';
import { useRenderRecord } from 'views/Aide/OutStock/MarkRecord';

type StockManageProps = {
  product: Conversation.Product;
  conversation: Conversation.Conversation;
};

const StockManage = memo((props: StockManageProps) => {
  const { product, conversation } = props;
  const { t } = useTranslate();
  const [open, instance] = useSkuMarkStock(product, conversation);
  const [open2, instance2] = useNonSkuMarkStock(product, conversation);
  const [open3, instance3] = useMark(product, conversation);
  const getPermission = useGetPermission();
  const markPerm = getPermission('标记商品缺货');
  const statusLabel = useMemo(() => {
    const status = product.spuStockStatus;
    if (status === 'InStock') {
      return t('stock.exist');
    }
    if (status === 'OutOfStock') {
      return t('ViewDashboard.LAZADA.Out of stock');
    }
    if (status === 'PartialOutOfStock') {
      return t('outofstock_partial_sku_out');
    }
    return '';
  }, [t, product]);

  const estimatedAvailableTime = product.estimatedAvailableTime;
  const renderRecord = useRenderRecord();

  return (
    <div className="flex items-center flex-shrink-0 max-w-[60%] mr-[4px]">
      {instance}
      {instance2}
      {instance3}
      <div className="inline-flex items-center leading-[20px] text-[#84868c] basis-auto overflow-hidden">
        <Typography.Text className="basis-auto overflow-hidden" ellipsis={{ tooltip: true }}>
          {statusLabel}
        </Typography.Text>
        {!!estimatedAvailableTime && (
          <Tooltip title={`${t('outofstock_youhuoriqi')}：${estimatedAvailableTime}`}>
            <InfoCircleOutlined className="ml-[6px]" />
          </Tooltip>
        )}
        {markPerm && (
          <Tooltip title={t('outofstock_mark_it')}>
            <FormOutlined
              className="ml-[6px] cursor-pointer"
              onClick={() => {
                if (product.skuInfo?.length === 0) {
                  // 缺货且已人工标记缺货
                  if (
                    (product.spuStockStatus === 'OutOfStock' ||
                      product.spuStockStatus === 'PartialOutOfStock') &&
                    product.stockFlag
                  ) {
                    open2();
                  } else {
                    open3();
                  }
                } else {
                  if (
                    product.spuStockStatus === 'InStock' ||
                    product.spuStockStatus === 'PartialOutOfStock'
                  ) {
                  }
                  open();
                }
              }}
            />
          </Tooltip>
        )}
        {!!Number(product.stockRuleOperateLogData?.operateUserId) && (
          <Tooltip title={renderRecord(product.stockRuleOperateLogData)}>
            <FileSearchOutlined className="ml-[6px]" />
          </Tooltip>
        )}
      </div>
    </div>
  );
});

export default StockManage;
